/**
 * Offline workout logging (flag offline_workout_logging). See sync_engine.js
 * for the overview. Everything here is inert with the flag off.
 */
import { initOfflineSync } from "./sync_engine";
import { mountOfflineIndicator } from "./offline_indicator";

export {
  keepVideoForLater,
  hasPendingOfflineWork,
  OFFLINE_VIDEO_UPLOADED_EVENT,
} from "./sync_engine";
export { isOfflineLoggingEnabled } from "./offline_flag";
export { mintIdempotencyKey } from "./set_save_queue";
export { isOnline, setNativeConnectivity } from "./connectivity";

export const startOfflineSync = () =>
  initOfflineSync({ mountIndicator: mountOfflineIndicator });
